export const CandidateSearchFilters = {
  expandFa: {
    ALL: 'all',
    TOP: 'top',
    PRIMARY: 'primary',
  },
} as const;
